import { lazy } from 'react';

export const dashboardRoutes = [
  {
    page: 'Active Referral Dashboard',
    path: '/dashboards/activeReferral',
    component: lazy(() => import('src/views/dashboards/dashboardsView')),
  },
  {
    path: '/dashboards/activeCases',
    component: lazy(() => import('src/views/dashboards/activeDonor')),
    permission: {
      readPermission: 'read:dashboardActiveCases',
    },
  },
];
